<template>
  <div v-show="show" class="modal-pad-switch" @click="$emit('click', !show)"></div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  }
};
</script>
